module.exports = __webpack_public_path__ + "static/media/logo-red.7417bd8b.jpg";